import type { WorkflowOverviewItem, WorkflowOverviewGroup } from './types'

export function isWorkflowOverviewGroup(
  item: WorkflowOverviewItem | WorkflowOverviewGroup
): item is WorkflowOverviewGroup {
  return item?.type === 'group'
}

export function isWorkflowOverviewItem(
  item: WorkflowOverviewItem | WorkflowOverviewGroup
): item is WorkflowOverviewItem {
  return item?.type === 'account_entry' || item?.type === 'reconciliation_text'
}
